
import { useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ExpertSection from './components/ExpertSection';
import TreatmentsSection from './components/TreatmentsSection';
import ReviewsSection from './components/ReviewsSection';
import PapilomaCenterSection from './components/PapilomaCenterSection';
import GallerySection from './components/GallerySection';
import EducationSection from './components/EducationSection';
import AppointmentSection from './components/AppointmentSection';
import Footer from './components/Footer';
import FixedCTA from './components/FixedCTA';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white font-inter">
      <Header />
      <main>
        <HeroSection />
        <ExpertSection />
        <TreatmentsSection />
        <ReviewsSection />
        <PapilomaCenterSection />
        <GallerySection />
        <EducationSection />
        <AppointmentSection />
      </main>
      <Footer />
      <FixedCTA />
    </div>
  );
}
